import { usePipelineJobs } from '@/hooks/useAdminActions'
import { AdminError } from './AdminError'

const JOB_STATUS_CLS: Record<string, string> = {
  done: 'status--ready',
  running: 'status--generating',
  queued: 'status--pending',
  error: 'status--error',
}

function formatTime(value: string | null) {
  if (!value) return 'n/a'
  return new Date(value).toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  })
}

function duration(started: string | null, finished: string | null) {
  if (!started || !finished) return 'n/a'
  const ms = new Date(finished).getTime() - new Date(started).getTime()
  if (ms < 0) return 'n/a'
  return ms < 60_000 ? `${Math.round(ms / 1000)}s` : `${Math.round(ms / 60_000)}m`
}

export function PipelineJobsPanel({ clientId }: { clientId: string }) {
  const { data: jobs, isLoading, error } = usePipelineJobs(clientId)

  return (
    <div className="admin-section">
      <div className="admin-section-head">
        <h2 className="admin-section-title">Pipeline Jobs</h2>
      </div>

      <p className="admin-empty-hint">
        Work runs on demand: headlines are pulled and stories built when someone
        opens the app, so there is nothing to kick off from here.
      </p>

      <AdminError error={error} />

      {isLoading ? (
        <p className="admin-empty-hint">Loading jobs…</p>
      ) : !jobs?.length ? (
        <p className="admin-empty-hint">No pipeline jobs recorded for this client.</p>
      ) : (
        <table className="admin-briefs-table">
          <thead>
            <tr><th>Type</th><th>Status</th><th>Started</th><th>Took</th><th>Error</th></tr>
          </thead>
          <tbody>
            {jobs.map((job) => (
              <tr key={job.id}>
                <td className="mono">{job.type}</td>
                <td><span className={`status-pill ${JOB_STATUS_CLS[job.status] ?? ''}`}>{job.status}</span></td>
                <td>{formatTime(job.started_at ?? job.created_at)}</td>
                <td>{duration(job.started_at, job.finished_at)}</td>
                <td className="admin-job-error" title={job.error ?? undefined}>{job.error ?? 'n/a'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
